import InstitutionService from 'src/common/api/institution.service';

export async function getAllInstitutions({ commit }) {
  const response = await InstitutionService.getAllInstitutions();
  if (response.status === 200) {
    commit('setAll', { all: response.data });
  }
}

export async function getInstitution({ commit }, { id }) {
  const response = await InstitutionService.getInstitution({ id });
  if (response.status === 200) {
    commit('setSingle', { single: response.data });
  }
}

export async function createInstitution(context, {
  address, phoneNumber, email, website, googlePlaceId, options, translations,
}) {
  await InstitutionService.createInstitution({
    address,
    phoneNumber,
    email,
    website,
    googlePlaceId,
    options,
    translations,
  });
}

export async function updateInstitution(context, {
  id, address, phoneNumber, email, website, googlePlaceId, options, translations,
}) {
  await InstitutionService.updateInstitution({
    id,
    address,
    phoneNumber,
    email,
    website,
    googlePlaceId,
    options,
    translations,
  });
}

export async function deleteInstitution({ dispatch }, { id }) {
  const response = await InstitutionService.deleteInstitution({ id });
  if (response.status === 200) {
    dispatch('getAllInstitutions');
  }
}
